import React from 'react';
import Card from "components/card";
import { FiSearch } from "react-icons/fi";
import { useSearchParams } from 'react-router-dom';
import Spinner from '../../../components/spinner';
import { listAmountCollected } from '../../../stores/ApiHelper';
// import DateRangePicker from 'components/DateRangePicker/DateRangePicker';
import { startOfDay, startOfMonth, startOfQuarter, startOfWeek, startOfYear } from 'date-fns';
import AmountCollectedTransactionTable from './components/AmountCollectedTransactionTable';

const inactiveDateRangeClasses =
    'rounded-xl bg-navy-700 px-5 py-3 text-sm font-medium text-white transition duration-200 hover:bg-navy-800 active:bg-navy-900 dark:bg-white/10 dark:text-white dark:hover:bg-white/20 dark:active:bg-white/30';
const activeDateRangeClasses =
    'rounded-xl bg-blue-500 px-5 py-3 text-sm font-medium text-white transition duration-200 hover:bg-blue-600 active:bg-blue-700 dark:bg-blue-400 dark:text-white dark:hover:bg-blue-300 dark:active:bg-blue-200';

const EasySplitOps: React.FC<{}> = () => {
    let [searchParams, setSearchParams] = useSearchParams();
    const search = searchParams.get("search");
    const [searchString, setSearchString] = React.useState<string>(search);
    const startDate = searchParams.get("startdate");
    const endDate = searchParams.get("enddate");
    const since = searchParams.get("since");
    const [loading, setLoading] = React.useState(true);
    const [tableData, setTableData] = React.useState<any>({ transactions: [], startDate: "", endDate: "", page: 1, pageSize: 25, itemCount: 0, totalPageCount: 0, hasPreviousPage: false, hasNextPage: false });

    React.useEffect(() => {
        const getStartDate = (): string => {
            if (since === 'quarter') {
                return startOfQuarter(new Date()).toISOString();
            } else if (since === 'year') {
                return startOfYear(new Date()).toISOString();
            } else if (since === 'month') {
                return startOfMonth(new Date()).toISOString();
            } else if (since === 'week') {
                return startOfWeek(new Date()).toISOString();
            } else if (since === 'day') {
                return startOfDay(new Date()).toISOString();
            }
            else if (since === 'custom') {
                return startDate;
            }
            return startDate;
        }
        const getEndDate = (): string => {
            if (since === "custom") {
                return endDate;
            }
            return endDate;
        }
        const getAmountCollected = async () => {
            try {
                setLoading(true);
                const response = await listAmountCollected(search, getStartDate(), getEndDate());
                if (response.data?.status === "success" && response.data.data) {
                    setTableData(response.data.data);
                }
            } catch (err) {

            } finally {
                setLoading(false);
            }
        }
        getAmountCollected();
    }, [search, startDate, endDate, since]);

    const setNewSearchParams = (newSearch?: string, newSince?: string, newStartDate?: string, newEndDate?: string) => {
        let q: any = {};
        if (newSearch) q.search = newSearch;
        if (newSince) q.since = newSince;
        if (newStartDate) q.startdate = newStartDate;
        if (newEndDate) q.enddate = newEndDate;
        setSearchParams(new URLSearchParams(q));
    }

    const onClickSince = (newSince: string) => {
        setNewSearchParams(searchString, newSince === since ? undefined : newSince);
    }

    // const onClickCustomSince = (newStartDate: Date, newEndDate: Date) => {
    //     setNewSearchParams(searchString, since, newStartDate.toISOString(), newEndDate.toISOString());
    // }

    const onClickSearch = (newSearch: string) => {
        setNewSearchParams(newSearch, since);
    }

    return (
        <Card extra={'w-full h-full sm:overflow-auto'}>
            <header className="relative flex items-center justify-between px-6 pt-4">
                <div className="text-xl font-bold text-navy-700 dark:text-white">Easy split</div>
            </header>

            <div className="mt-10 flex flex-row justify-end gap-3 px-6">
                <div className="flex flex-row justify-end gap-3">
                    <div className="flex h-full items-center rounded-full bg-lightPrimary text-navy-700 dark:bg-navy-900 dark:text-white xl:w-[225px]">
                        <p className="text-xl pe-2 ps-3">
                            <FiSearch className="h-4 w-4 text-gray-400 dark:text-white" />
                        </p>
                        <input
                            type="text"
                            placeholder="referenceId or UTR"
                            className="block h-full w-full rounded-full bg-lightPrimary text-sm font-medium text-navy-700 outline-none placeholder:!text-gray-400 dark:bg-navy-900 dark:text-white dark:placeholder:!text-white sm:w-fit"
                            value={searchString ? searchString : ''}
                            onChange={e => setSearchString(e.target.value)}
                            onKeyDown={(e) => { if (e.key === "Enter") onClickSearch(searchString); }}
                        />
                    </div>
                    {[
                        { label: 'Today', value: 'day' },
                        { label: 'Week', value: 'week' },
                        { label: 'Month', value: 'month' },
                        { label: 'Quarter', value: 'quarter' },
                        {
                            label: 'Year',
                            value: 'year',
                        },
                    ].map((item) => (
                        <button
                            key={item.value}
                            onClick={((e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                onClickSince(item.value);
                            })}
                            className={since === item.value ? activeDateRangeClasses : inactiveDateRangeClasses}
                        >
                            {item.label}
                        </button>
                    ))}
                    {/* <DateRangePicker active={since === "custom"} onChange={onClickCustomSince} /> */}
                </div>
            </div>
            {
                loading ? (
                    <Spinner />
                ) : (
                    <AmountCollectedTransactionTable transactions={tableData.transactions} />
                )
            }
        </Card>
    )
}

export default EasySplitOps;